import { EditOutlined, LogoutOutlined } from '@ant-design/icons';
import { history, useIntl } from '@umijs/max';
import type { MenuProps } from 'antd';
import React from 'react';
import HeaderDropdown from '../HeaderDropdown';
import { useState } from 'react';
import ModalChangePassword from '../ChangePassword';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  return <span className="anticon">Admin</span>;
};

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  const { formatMessage } = useIntl();
  const [openChangePassword, setOpenChangePassword] = useState(false);

  const loginOut = async () => {
    if (window.location.pathname !== '/user/login') {
      localStorage.clear();
      history.replace({
        pathname: '/user/login',
      });
    }
  };

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      loginOut();
      return;
    }
    if (key === 'change-password') {
      setOpenChangePassword(true);
      return;
    }
    history.push(`/account/${key}`);
  };

  const menuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: formatMessage({ id: 'pages.account.logout' }),
    },
    {
      key: 'change-password',
      label: formatMessage({ id: 'pages.account.change_password' }),
      icon: <EditOutlined />,
    },
  ];

  return (
    <>
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        {children}
      </HeaderDropdown>
      <ModalChangePassword open={openChangePassword} onClose={() => setOpenChangePassword(false)} />
    </>
  );
};
